import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import $ from 'jquery';
import {bindActionCreators} from 'redux';
import QRCode from 'qrcode.react';
import {maxValueMonetario, renderFieldCpfCnpj, renderFieldDataNascimento, renderFieldMonetario, renderTextArea, required, validarCpfCnpjInformado} from '../../../util/inputs';
import {realParaNumber} from '../../../util/numberUtil';
import enviarFechamentoCaixa from '../../../actions/fechamento-caixa/usuario/enviarFechamentoCaixa';
import {
    getAdminEmpresa,
    getFinanceiroAgencia, getFinanceiroCaixa,
    getGestorEmpresa,
    getOperadorEmpresa,
    getPerfisVendedores,
} from '../../../security/securityContext';
import Autorizacao, {validaPerfis} from '../../../security/Autorizacao';
import devolverFechamentoCaixa from '../../../actions/fechamento-caixa/usuario/devolverFechamentoCaixa';
import baixarComprovanteTransferencia from '../../../actions/fechamento-caixa/usuario/baixarComprovanteTransferencia';
import aprovarFechamentoCaixa from '../../../actions/fechamento-caixa/usuario/aprovarFechamentoCaixa';
import buscarComprovantesPagamento from '../../../actions/fechamento-caixa/usuario/buscarComprovantesPagamento';
import {tamanhoArquivoUpload} from '../../../util/applicationContext';
import buscarFechamentoDia from '../../../actions/fechamento-caixa/usuario/buscarFechamentoDia';
import buscarFechamentosCaixa from '../../../actions/fechamento-caixa/usuario/buscarFechamentosCaixa';
import salvarFechamentoCaixa from '../../../actions/fechamento-caixa/usuario/salvarFechamentoCaixa';
import gerarPixFechamentoCaixa from '../../../actions/fechamento-caixa/usuario/gerarPixFechamentoCaixa';
import verificarPagamentoPixFechamentoCaixa from '../../../actions/fechamento-caixa/usuario/verificarPagamentoPixFechamentoCaixa';
import gerarPixFechamentoCaixaSicoob from '../../../actions/fechamento-caixa/usuario/gerarPixFechamentoCaixaSicoob';
import verificarPagamentoPixFechamentoCaixaSicoob from '../../../actions/fechamento-caixa/usuario/verificarPagamentoPixFechamentoCaixaSicoob';
import {usuarioEmpresaHabilitadoCieloEcommerce, usuarioEmpresaHabilitadoSicoob} from '../../../actions/usuario/cadastrarUsuariosEmpresaEmLote';
import {showErrorMsg, showSuccessMsg} from '../../../util/messagesUtil';

export class ModalFechamentoCaixa extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comprovante: null,
            nomeComprovante: null,
            comprovantesPagamento: [],
            pixAguardando: false,
            pixQrCode: null,
            pixCopiaECola: null,
            pixGeradoEm: null,
            pixSituacaoAprovada: false,
            pixCodigoTransacao: null,
            pixSicoobAguardando: false,
            pixSicoobCopiaECola: null,
            pixSicoobGeradoEm: null,
            pixSicoobSituacaoAprovada: false,
            pixSicoobCodigoTransacao: null
        };
        this.submit = this.submit.bind(this);
        this.alterarValorTotal = this.alterarValorTotal.bind(this);
        this.alterarValorDespesas = this.alterarValorDespesas.bind(this);
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        this.buscarComprovantes();
        this.retomarPollingPixSeNecessario();
        this.retomarPollingPixSicoobSeNecessario();
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.props.usuarioEmpresaHabilitadoCieloEcommerce(this.props.empresaSelecionada.id);
            this.props.usuarioEmpresaHabilitadoSicoob(this.props.empresaSelecionada.id);
        }
    }

    componentDidUpdate(prevProps) {
        // Se o fechamento mudou, buscar os comprovantes novamente
        if (prevProps.fechamentoCaixa.id !== this.props.fechamentoCaixa.id) {
            this.buscarComprovantes();
            this.setState({ pixQrCode: null, pixCopiaECola: null, pixGeradoEm: null,
                            pixSituacaoAprovada: false, pixCodigoTransacao: null,
                            pixSicoobCopiaECola: null, pixSicoobGeradoEm: null,
                            pixSicoobSituacaoAprovada: false, pixSicoobCodigoTransacao: null });
            clearInterval(this.pollingIntervalPix);
            clearInterval(this.pollingIntervalPixSicoob);
            this.retomarPollingPixSeNecessario();
            this.retomarPollingPixSicoobSeNecessario();
        }
    }

    componentWillUnmount() {
        clearInterval(this.pollingIntervalPix);
        clearInterval(this.pollingIntervalPixSicoob);
    }

    // o modal de fechamento (ao contrário da venda de passagens, fluxo de uma sessão só)
    // pode ser fechado e reaberto com um PIX ainda pendente -- retoma o polling nesse caso
    retomarPollingPixSeNecessario() {
        if (this.props.fechamentoCaixa.situacaoPagamentoPix === 'PENDENTE' && this.pixDepositoAtivo()) {
            this.pollingIntervalPix = setInterval(() => this.verificarPix(), 15000);
        }
    }

    // QR Code PIX da Cielo vale por 30 minutos, mesma janela usada em
    // ModalAlterarFormaPagamento.js (cieloEcommercePixAtivo). Prioriza o horário local
    // (pixGeradoEm) quando o QR foi gerado nesta sessão -- o dataGeracaoPix vindo do
    // backend só é atualizado na próxima busca do fechamento, então logo após gerar um
    // QR novo ele ainda estaria com o valor antigo (expirado) sem esse fallback.
    pixDepositoAtivo() {
        if (this.state.pixGeradoEm) {
            return (Date.now() - this.state.pixGeradoEm) < 30 * 60 * 1000;
        }
        const dataGeracaoPix = this.props.fechamentoCaixa.dataGeracaoPix;
        if (!dataGeracaoPix) return false;
        return (Date.now() - new Date(dataGeracaoPix).getTime()) < 30 * 60 * 1000;
    }

    // mesma lógica de retomarPollingPixSeNecessario/pixDepositoAtivo, mas para Sicoob
    retomarPollingPixSicoobSeNecessario() {
        if (this.props.fechamentoCaixa.situacaoPagamentoPixSicoob === 'PENDENTE' && this.pixDepositoSicoobAtivo()) {
            this.pollingIntervalPixSicoob = setInterval(() => this.verificarPixSicoob(), 15000);
        }
    }

    pixDepositoSicoobAtivo() {
        if (this.state.pixSicoobGeradoEm) {
            return (Date.now() - this.state.pixSicoobGeradoEm) < 30 * 60 * 1000;
        }
        const dataGeracaoPixSicoob = this.props.fechamentoCaixa.dataGeracaoPixSicoob;
        if (!dataGeracaoPixSicoob) return false;
        return (Date.now() - new Date(dataGeracaoPixSicoob).getTime()) < 30 * 60 * 1000;
    }

    gerarPix() {
        this.setState({ pixAguardando: true });
        this.props.gerarPixFechamentoCaixa(this.props.fechamentoCaixa.id, this.props.empresaSelecionada.id)
            .then((resp) => {
                const { qrCodeBase64, copiaECola, codigoTransacao } = resp.payload.data;
                this.setState({ pixAguardando: false, pixQrCode: qrCodeBase64, pixCopiaECola: copiaECola,
                                 pixCodigoTransacao: codigoTransacao, pixGeradoEm: Date.now() });
                clearInterval(this.pollingIntervalPix);
                this.pollingIntervalPix = setInterval(() => this.verificarPix(), 15000);
            })
            .catch((error) => {
                this.setState({ pixAguardando: false, pixQrCode: null, pixCopiaECola: null });
                const texto = error.response && error.response.data && error.response.data.mensagens
                    ? error.response.data.mensagens[0].mensagem
                    : 'Não foi possível gerar o QR Code PIX. Tente novamente.';
                showErrorMsg(texto);
            });
    }

    verificarPix() {
        this.props.verificarPagamentoPixFechamentoCaixa(this.props.fechamentoCaixa.id, this.props.empresaSelecionada.id)
            .then((resp) => {
                if (resp.payload.data === 'APROVADO') {
                    clearInterval(this.pollingIntervalPix);
                    this.setState({ pixSituacaoAprovada: true, pixQrCode: null, pixCopiaECola: null });
                }
                if (resp.payload.data === 'CANCELADO' || resp.payload.data === 'EXPIRADO') {
                    clearInterval(this.pollingIntervalPix);
                }
            });
    }

    gerarPixSicoob() {
        this.setState({ pixSicoobAguardando: true });
        this.props.gerarPixFechamentoCaixaSicoob(this.props.fechamentoCaixa.id, this.props.empresaSelecionada.id)
            .then((resp) => {
                const { copiaECola, codigoTransacao } = resp.payload.data;
                this.setState({ pixSicoobAguardando: false, pixSicoobCopiaECola: copiaECola,
                                 pixSicoobCodigoTransacao: codigoTransacao, pixSicoobGeradoEm: Date.now() });
                clearInterval(this.pollingIntervalPixSicoob);
                this.pollingIntervalPixSicoob = setInterval(() => this.verificarPixSicoob(), 15000);
            })
            .catch((error) => {
                this.setState({ pixSicoobAguardando: false, pixSicoobCopiaECola: null });
                const texto = error.response && error.response.data && error.response.data.mensagens
                    ? error.response.data.mensagens[0].mensagem
                    : 'Não foi possível gerar o QR Code PIX. Tente novamente.';
                showErrorMsg(texto);
            });
    }

    verificarPixSicoob() {
        this.props.verificarPagamentoPixFechamentoCaixaSicoob(this.props.fechamentoCaixa.id, this.props.empresaSelecionada.id)
            .then((resp) => {
                if (resp.payload.data === 'APROVADO') {
                    clearInterval(this.pollingIntervalPixSicoob);
                    this.setState({ pixSicoobSituacaoAprovada: true, pixSicoobCopiaECola: null });
                }
                if (resp.payload.data === 'CANCELADO' || resp.payload.data === 'EXPIRADO') {
                    clearInterval(this.pollingIntervalPixSicoob);
                }
            });
    }

    buscarComprovantes() {
        if (this.props.fechamentoCaixa && this.props.fechamentoCaixa.id && this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            buscarComprovantesPagamento(this.props.empresaSelecionada.id, this.props.fechamentoCaixa.id)
                .then((response) => {
                    this.setState({ comprovantesPagamento: response.data || [] });
                })
                .catch((error) => {
                    console.error('Erro ao buscar comprovantes de pagamento:', error);
                    this.setState({ comprovantesPagamento: [] });
                });
        } else {
            this.setState({ comprovantesPagamento: [] });
        }
    }

    valorDiferenteZero(valor){
        const valorConvertido = realParaNumber(valor)
        return  valorConvertido > 0 || valorConvertido < 0
    }

    validarValoresReaisInfomados() {
        return this.valorDiferenteZero(this.props.totalAdiantamentoBaixado) ||
            this.valorDiferenteZero(this.props.totalAdiantamentoLancado) ||
            this.valorDiferenteZero(this.props.totalDespesas) ||
            this.valorDiferenteZero(this.props.totalLancamentoAReceber) ||
            this.valorDiferenteZero(this.props.totalDeposito) ||
            this.valorDiferenteZero(this.props.totalVendas)

    }

    validarCamposTextoInformados(){
        // eslint-disable-next-line no-undef
        return !_.isNil(this.props.observacao) || !_.isNil(this.props.base64ComprovanteTransferencia);
    }

    fecharModal() {
        $('#modalFechamentoCaixa')
            .modal('hide');
        $('#modalFechamentoCaixa')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.reset('formularioFechamentoCaixa')
    }

    submit(values) {
        const parametros = {
            totalTaxaEmbarqueCEA: values.totalTaxaEmbarqueCEA.replace('R$', ''),
            totalTaxaServico: values.totalTaxaServico.replace('R$', ''),
            totalAdiantamentoBaixado: values.totalAdiantamentoBaixado.replace('R$', ''),
            totalAdiantamentoLancado: values.totalAdiantamentoLancado.replace('R$', ''),
            totalDespesas: values.totalDespesas.replace('R$', ''),
            totalImpostoRetido: values.totalImpostoRetido.replace('R$', ''),
            totalTarifaSeguroImpostoRetido: values.totalTarifaSeguroImpostoRetido.replace('R$', ''),
            totalLancamentoAReceber: values.totalLancamentoAReceber.replace('R$', ''),
            observacao: values.observacao,
            base64ComprovanteTransferencia: this.props.base64ComprovanteTransferencia,
            nomeComprovanteTransferencia: this.props.nomeComprovanteTransferencia,
            data: this.props.fechamentoCaixa.dataFechamento,
            idUsuarioEmpresa: this.props.fechamentoCaixa.idUsuarioEmpresa,
            cpfCnpjTitularComprovante: values.cpfCnpjTitularComprovante,
            dataComprovanteDeposito: values.dataComprovanteDeposito,
            
        };
        if (this.state.botao === 'salvar') {            
            this.salvarFechamento(parametros)
        } else {
            if (this.props.empresaSelecionada.habilitadoCpfCnpjTitularComprovante && (!values.cpfCnpjTitularComprovante || !values.dataComprovanteDeposito)) {
                showErrorMsg('Informe os dados CPF/CNPJ TITULAR do Comprovante e DATA Comprovante Deposito');
                return;
            }
            this.enviarFechamento(parametros)
        }
    }

    enviarFechamento(parametros) {
        this.props.enviarFechamentoCaixa(this.props.empresaSelecionada.id, parametros)
            .then(() => {
                showSuccessMsg('Fechamento enviado com sucesso');
                this.fecharModal();
                this.props.buscarFechamentosCaixa(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
                this.props.buscarFechamentoDia(this.props.empresaSelecionada.id)
            })
    }

    salvarFechamento(parametros) {
        this.props.salvarFechamentoCaixa(this.props.empresaSelecionada.id, parametros)
            .then(() => {
                showSuccessMsg('Fechamento salvo com sucesso');
                this.fecharModal();
                this.props.buscarFechamentosCaixa(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
                this.props.buscarFechamentoDia(this.props.empresaSelecionada.id)
            })
    }

    handleChange(event) {
        const file = event.target.files[0];
        if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
            return
        }
        if (file.size > tamanhoArquivoUpload) {
            showErrorMsg('Tamanho do arquivo excede 20 MB');
            return
        }
        this.converterParaBase64(file)
    }

    removerArquivo() {
        this.props.changeFieldValue('formularioFechamentoCaixa',
            'base64ComprovanteTransferencia', null);
        this.props.changeFieldValue('formularioFechamentoCaixa',
            'nomeComprovanteTransferencia', null);
        this.props.changeFieldValue('formularioFechamentoCaixa',
            'urlComprovanteTransferencia', null);
    }

    converterParaBase64(file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            this.props.changeFieldValue('formularioFechamentoCaixa',
                'base64ComprovanteTransferencia', reader.result);
            this.props.changeFieldValue('formularioFechamentoCaixa',
                'nomeComprovanteTransferencia', file.name);
        }.bind(this);
    }

    alterarValorDespesas(event) {
        event.preventDefault();
        // Pega o valor atual do totalDeposito
        let valorDeposito = realParaNumber(this.props.totalDeposito);
        
        // Remove o valor antigo de despesas (adiciona de volta, pois foi subtraído antes)
        const valorDespesasAntigo = realParaNumber(this.props.totalDespesas);
        valorDeposito = valorDeposito + valorDespesasAntigo;
        
        // Subtrai o novo valor de despesas informado
        const novoValorDespesas = realParaNumber(event.target.value);
        valorDeposito = valorDeposito - novoValorDespesas;
        
        // Atualiza o totalDeposito
        this.props.changeFieldValue('formularioFechamentoCaixa',
            'totalDeposito', valorDeposito.toString().replace('.', ','));
    }


    alterarValorTotal = (event) => {
        event.preventDefault();
        let valor = realParaNumber(this.props.totalVendas);

        valor = this.calcularValor(valor, event, 'totalFreteRecebido', this.props.totalFreteRecebido, true);
        valor = this.calcularValor(valor, event, 'totalExcessoBagagem', this.props.totalExcessoBagagem, true);
        valor = this.calcularValor(valor, event, 'totalTaxaServico', this.props.totalTaxaServico, true);
        valor = this.calcularValor(valor, event, 'totalAdiantamentoBaixado', this.props.totalAdiantamentoBaixado, true);
        valor = this.calcularValor(valor, event, 'totalCustoCancelamento', this.props.totalCustoCancelamento, true);
        valor = this.calcularValor(valor, event, 'totalCancelamento', this.props.totalCancelamento);
        valor = this.calcularValor(valor, event, 'totalAdiantamentoLancado', this.props.totalAdiantamentoLancado);
        valor = this.calcularValor(valor, event, 'totalImpostoRetido', this.props.totalImpostoRetido);
        valor = this.calcularValor(valor, event, 'totalTarifaSeguro', this.props.totalTarifaSeguro);
        valor = this.calcularValor(valor, event, 'totalComissao', this.props.totalComissao);
        valor = this.calcularValor(valor, event, 'totalDesconto', this.props.totalDesconto);
        valor = this.calcularValor(valor, event, 'totalRecebidoCartao', this.props.totalRecebidoCartao);
        valor = this.calcularValor(valor, event, 'totalRecebidoCartaoSite', this.props.totalRecebidoCartaoSite);
//        valor = this.calcularValor(valor, event, 'totalTarifaSeguroImpostoRetido', this.props.totalTarifaSeguroImpostoRetido);
        valor = this.calcularValor(valor, event, 'totalLancamentoAReceber', this.props.totalLancamentoAReceber);
        this.props.changeFieldValue('formularioFechamentoCaixa',
            'totalDeposito', valor.toString()
                .replace('.', ','));
    };

    calcularValor(valorTotal, event, nomeCampo, total, isSoma) {
        const valor = event.target.name === nomeCampo ? realParaNumber(event.target.value) : realParaNumber(total);
        return isSoma ? valorTotal + valor : valorTotal - valor;
    }

    exibirPixDeposito() {
        // pixSituacaoAprovada cobre a aprovação detectada pelo polling na sessão atual --
        // situacaoPagamentoPix (props) só reflete isso depois de o fechamento ser buscado de
        // novo (reabrir o modal, por exemplo)
        if (this.state.pixSituacaoAprovada || this.props.fechamentoCaixa.situacaoPagamentoPix === 'APROVADO') {
            const codigoTransacao = this.state.pixCodigoTransacao || this.props.fechamentoCaixa.codigoTransacaoPix;
            return (
                <div className="vx-summary-waiting" style={{ color: '#4caf50' }}>
                    <i className="material-icons" style={{ color: '#4caf50' }}>check_circle</i>
                    Código da transação: {codigoTransacao}
                </div>
            )
        }

        const situacaoPermiteGerarPix = !!this.props.fechamentoCaixa.id
            && (this.props.fechamentoCaixa.situacao === 'ABERTO'
                || this.props.fechamentoCaixa.situacao === 'DEVOLVIDO');
        if (!situacaoPermiteGerarPix) {
            return '';
        }

        const copiaECola = this.state.pixCopiaECola || this.props.fechamentoCaixa.copiaColaPix;
        const valorDepositoZerado = !this.valorDiferenteZero(this.props.totalDeposito);

        if (this.props.fechamentoCaixa.situacaoPagamentoPix === 'PENDENTE' && copiaECola && !this.pixDepositoAtivo()) {
            if (valorDepositoZerado) {
                return (
                    <div className="vx-summary-tef-alert">
                        <i className="material-icons">warning</i>
                        <span>O valor do depósito está zerado. Informe um valor para gerar um novo QR Code PIX.</span>
                    </div>
                )
            }
            return (
                <div>
                    <div className="vx-summary-tef-alert">
                        <i className="material-icons">warning</i>
                        <span>O QR Code PIX expirou (validade de 30 minutos). Gere um novo para continuar.</span>
                    </div>
                    <button type="button" className="vx-modal-btn-confirmar"
                            disabled={this.state.pixAguardando}
                            onClick={() => this.gerarPix()}>
                        <i className="material-icons" style={{ fontSize: 16 }}>pix</i>
                        Gerar Novo QR Code PIX
                    </button>
                </div>
            )
        }

        if (!copiaECola) {
            if (valorDepositoZerado) {
                return (
                    <div className="vx-summary-tef-alert">
                        <i className="material-icons">warning</i>
                        <span>O valor do depósito está zerado. Informe um valor para gerar o QR Code PIX.</span>
                    </div>
                )
            }
            return (
                <button type="button" className="vx-modal-btn-confirmar"
                        disabled={this.state.pixAguardando}
                        onClick={() => this.gerarPix()}>
                    <i className="material-icons" style={{ fontSize: 16 }}>pix</i>
                    Gerar QR Code PIX
                </button>
            )
        }

        return (
            <div className="vx-summary-qr-card">
                <div className="vx-summary-qr-title">
                    <i className="material-icons">check_circle</i>
                    QR Code PIX gerado!
                </div>
                <QRCode value={copiaECola} size={180}/>
                <p className="vx-summary-qr-url">{copiaECola}</p>
                <div className="vx-summary-qr-actions">
                    <button className="vx-summary-qr-copy-btn"
                            onClick={() => navigator.clipboard.writeText(copiaECola)}>
                        <i className="material-icons" style={{ fontSize: '16px' }}>content_copy</i>
                        Copiar Código PIX
                    </button>
                </div>
                <div className="vx-summary-waiting">
                    <i className="material-icons">sync</i>
                    Aguardando confirmação do pagamento...
                </div>
            </div>
        )
    }

    // mesma lógica de exibirPixDeposito, mas para Sicoob (sem imagem pronta -- o QR é
    // sempre renderizado a partir do copia-e-cola via QRCode, igual ao Cielo E-commerce)
    exibirPixDepositoSicoob() {
        if (this.state.pixSicoobSituacaoAprovada || this.props.fechamentoCaixa.situacaoPagamentoPixSicoob === 'APROVADO') {
            const codigoTransacao = this.state.pixSicoobCodigoTransacao || this.props.fechamentoCaixa.codigoTransacaoPixSicoob;
            return (
                <div className="vx-summary-waiting" style={{ color: '#4caf50' }}>
                    <i className="material-icons" style={{ color: '#4caf50' }}>check_circle</i>
                    Código da transação: {codigoTransacao}
                </div>
            )
        }

        const situacaoPermiteGerarPix = !!this.props.fechamentoCaixa.id
            && (this.props.fechamentoCaixa.situacao === 'ABERTO'
                || this.props.fechamentoCaixa.situacao === 'DEVOLVIDO');
        if (!situacaoPermiteGerarPix) {
            return '';
        }

        const copiaECola = this.state.pixSicoobCopiaECola || this.props.fechamentoCaixa.copiaColaPixSicoob;
        const valorDepositoZerado = !this.valorDiferenteZero(this.props.totalDeposito);

        if (this.props.fechamentoCaixa.situacaoPagamentoPixSicoob === 'PENDENTE' && copiaECola && !this.pixDepositoSicoobAtivo()) {
            if (valorDepositoZerado) {
                return (
                    <div className="vx-summary-tef-alert">
                        <i className="material-icons">warning</i>
                        <span>O valor do depósito está zerado. Informe um valor para gerar um novo QR Code PIX.</span>
                    </div>
                )
            }
            return (
                <div>
                    <div className="vx-summary-tef-alert">
                        <i className="material-icons">warning</i>
                        <span>O QR Code PIX expirou (validade de 30 minutos). Gere um novo para continuar.</span>
                    </div>
                    <button type="button" className="vx-modal-btn-confirmar"
                            disabled={this.state.pixSicoobAguardando}
                            onClick={() => this.gerarPixSicoob()}>
                        <i className="material-icons" style={{ fontSize: 16 }}>pix</i>
                        Gerar Novo QR Code PIX
                    </button>
                </div>
            )
        }

        if (!copiaECola) {
            if (valorDepositoZerado) {
                return (
                    <div className="vx-summary-tef-alert">
                        <i className="material-icons">warning</i>
                        <span>O valor do depósito está zerado. Informe um valor para gerar o QR Code PIX.</span>
                    </div>
                )
            }
            return (
                <button type="button" className="vx-modal-btn-confirmar"
                        disabled={this.state.pixSicoobAguardando}
                        onClick={() => this.gerarPixSicoob()}>
                    <i className="material-icons" style={{ fontSize: 16 }}>pix</i>
                    Gerar QR Code PIX
                </button>
            )
        }

        return (
            <div className="vx-summary-qr-card">
                <div className="vx-summary-qr-title">
                    <i className="material-icons">check_circle</i>
                    QR Code PIX gerado!
                </div>
                <QRCode value={copiaECola} size={180}/>
                <p className="vx-summary-qr-url">{copiaECola}</p>
                <div className="vx-summary-qr-actions">
                    <button className="vx-summary-qr-copy-btn"
                            onClick={() => navigator.clipboard.writeText(copiaECola)}>
                        <i className="material-icons" style={{ fontSize: '16px' }}>content_copy</i>
                        Copiar Código PIX
                    </button>
                </div>
                <div className="vx-summary-waiting">
                    <i className="material-icons">sync</i>
                    Aguardando confirmação do pagamento...
                </div>
            </div>
        )
    }

    exibirAnexar() {
        const ehGestorOuOperador = validaPerfis([
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroCaixa(this.props.empresaSelecionada.id),
            getOperadorEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroAgencia(this.props.empresaSelecionada.id)]);
        if (this.props.base64ComprovanteTransferencia || this.props.urlComprovanteTransferencia) {
            return (
                <div className="vx-modal-attach-file mt-2">
                    <span className="material-icons" style={{ color: '#FF6A00', fontSize: '20px', lineHeight: 1 }}>attach_file</span>
                    <span style={{ flex: 1, minWidth: 0, fontSize: '13px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{this.props.nomeComprovanteTransferencia}</span>
                    {this.exibirRemoverComprovante()}
                    {this.exibirBaixarComprovante()}
                </div>)
        }
        if (this.props.fechamentoCaixa.idUsuario === this.props.idUsuario || ehGestorOuOperador) {
            return (
                <Autorizacao perfisPermitidos={[
                    ...getPerfisVendedores(this.props.empresaSelecionada.id),
                    getGestorEmpresa(this.props.empresaSelecionada.id),
                    getFinanceiroCaixa(this.props.empresaSelecionada.id),
                    getOperadorEmpresa(this.props.empresaSelecionada.id),
                    getFinanceiroAgencia(this.props.empresaSelecionada.id)
                ]}>
                    <div className='input-wrapper mt-2'>
                        <label className='vx-file-upload-label' htmlFor='input-file'>
                            <i className="material-icons">upload_file</i>
                            Anexar comprovante de depósito
                        </label>
                        <input id='input-file' type='file' value='' accept="image/png,image/jpeg,application/pdf"
                               onChange={this.handleChange.bind(this)}/>
                    </div>
                    <p style={{ fontSize: '11px', color: '#888', margin: '4px 0 0' }}>
                        Máx. 20 MB · PNG, JPEG, PDF
                    </p>
                </Autorizacao>)
        }

        return '';
    }

    baixarComprovante(){
        baixarComprovanteTransferencia(this.props.comprovanteTransferencia, this.props.nomeComprovanteTransferencia).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.props.nomeComprovanteTransferencia);
            document.body.appendChild(link);

            link.click();

        });
    }

    exibirBaixarComprovante() {
        if (this.props.urlComprovanteTransferencia) {
            return (<Autorizacao perfisPermitidos={[
                ...getPerfisVendedores(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getFinanceiroAgencia(this.props.empresaSelecionada.id)
            ]}>
                <button type="button" className="vx-modal-attach-remove"
                        style={{ borderColor: '#28a745', color: '#28a745' }}
                        title='Baixar' onClick={() => this.baixarComprovante()}>
                    <span className="material-icons">download</span>
                    Baixar
                </button>
            </Autorizacao>)
        }
        return '';
    }

    exibirRemoverComprovante() {
        const ehGestorOuOperador = validaPerfis([
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getOperadorEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroCaixa(this.props.empresaSelecionada.id),
            getFinanceiroAgencia(this.props.empresaSelecionada.id)]);
        if ((this.props.fechamentoCaixa.situacao === 'ABERTO' || this.props.fechamentoCaixa.situacao === 'DEVOLVIDO') && (this.props.fechamentoCaixa.idUsuario === this.props.idUsuario || ehGestorOuOperador)) {
            return (<Autorizacao perfisPermitidos={[
                ...getPerfisVendedores(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroAgencia(this.props.empresaSelecionada.id)
            ]}>
                <button type="button" className="vx-modal-attach-remove"
                        title='Remover' onClick={() => this.removerArquivo()}>
                    <span className="material-icons">delete</span>
                </button>
            </Autorizacao>)
        }
    }

    baixarComprovantePagamento(identificacaoComprovante, nomeComprovante) {
        baixarComprovanteTransferencia(identificacaoComprovante, nomeComprovante || 'comprovante.pdf').then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nomeComprovante || 'comprovante.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }

    exibirComprovantesPagamento() {
        const comprovantes = this.state.comprovantesPagamento || [];

        if (comprovantes.length === 0) {
            return '';
        }

        return (
            <div className="vx-modal-section" style={{ marginTop: '8px' }}>
                <div className="vx-modal-section-title">
                    <i className="material-icons">receipt</i>
                    Comprovantes de Pagamento
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                    <thead>
                        <tr style={{ background: '#f5f5f5' }}>
                            <th style={{ padding: '6px 8px', borderBottom: '1px solid #e0e0e0', fontWeight: 600 }}>Nº Pedido</th>
                            <th style={{ padding: '6px 8px', borderBottom: '1px solid #e0e0e0', fontWeight: 600 }}>Forma Pagamento</th>
                            <th style={{ padding: '6px 8px', borderBottom: '1px solid #e0e0e0', fontWeight: 600 }}>Comprovante</th>
                        </tr>
                    </thead>
                    <tbody>
                        {comprovantes.map((comprovante, index) => (
                            <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                <td style={{ padding: '6px 8px' }}>{comprovante.idPedido}</td>
                                <td style={{ padding: '6px 8px' }}>{comprovante.descricaoFormaPagamento || '-'}</td>
                                <td style={{ padding: '6px 8px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        <span style={{ fontSize: '12px', color: '#555' }}>{comprovante.nomeComprovante || 'Sem comprovante'}</span>
                                        {comprovante.identificacaoComprovante && (
                                            <button
                                                type="button"
                                                className="vx-btn-success"
                                                style={{ padding: '2px 8px', fontSize: '12px' }}
                                                title="Baixar comprovante"
                                                onClick={() => this.baixarComprovantePagamento(
                                                    comprovante.identificacaoComprovante,
                                                    comprovante.nomeComprovante || `comprovante_pedido_${comprovante.idPedido}.pdf`
                                                )}>
                                                <i className="material-icons" style={{ fontSize: '14px' }}>download</i>
                                                Baixar
                                            </button>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    exibirBotoesVendedor(invalid, submitting, exibirBotaoSalvar) {
        const ehGestorOuOperador = validaPerfis([
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getOperadorEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroCaixa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroAgencia(this.props.empresaSelecionada.id)]);

        if (this.props.fechamentoCaixa.situacao === 'ABERTO' || this.props.fechamentoCaixa.situacao === 'DEVOLVIDO') {
            return (
                <div className="vx-modal-footer">
                    <button type="button" className="vx-btn-secondary" data-dismiss="modal" disabled={submitting}>
                        <i className="material-icons">close</i>Cancelar
                    </button>
                    {this.props.fechamentoCaixa.idUsuario === this.props.idUsuario || ehGestorOuOperador
                        ? <Autorizacao perfisPermitidos={[
                            ...getPerfisVendedores(this.props.empresaSelecionada.id),
                            getGestorEmpresa(this.props.empresaSelecionada.id),
                            getFinanceiroCaixa(this.props.empresaSelecionada.id),
                            getOperadorEmpresa(this.props.empresaSelecionada.id),
                            getFinanceiroAgencia(this.props.empresaSelecionada.id)
                        ]}>
                            <button type="submit" title='Salvar custos do dia' className="vx-btn-secondary"
                                    onClick={() => this.setState({botao: 'salvar'})} disabled={invalid || submitting || !exibirBotaoSalvar}>
                                <i className="material-icons">save</i>Salvar
                            </button>
                            <button type="submit" title='Enviar para aprovação do gestor' className="vx-btn-primary"
                                    onClick={() => this.setState({botao: 'enviar'})}
                                    disabled={invalid || submitting || !this.props.nomeComprovanteTransferencia}>
                                <i className="material-icons">send</i>Enviar
                            </button>
                        </Autorizacao> : ''}
                </div>)
        }
        return ''
    }

    devolverFechamentoCaixa() {
        this.props.devolverFechamentoCaixa(this.props.fechamentoCaixa.id, this.props.observacao, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Fechamento devolvido com sucesso');
                this.fecharModal();
                this.props.buscaFechamentos(this.props.data);
                this.props.buscarFechamentoDia(this.props.empresaSelecionada.id)
            })
    }

    aprovarFechamentoCaixa() {
        this.props.aprovarFechamentoCaixa(this.props.fechamentoCaixa.id, this.props.observacao, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Fechamento aprovado com sucesso');
                this.fecharModal();
                this.props.buscaFechamentos(this.props.data);
                this.props.buscarFechamentoDia(this.props.empresaSelecionada.id)
            })
    }


    exibirBotoesGestorOperador() {
        if (this.props.fechamentoCaixa.situacao === 'ENVIADO') {
            return (
                <div className="vx-modal-footer">
                    <button type="button" className="vx-btn-secondary" data-dismiss="modal">
                        <i className="material-icons">close</i>Cancelar
                    </button>
                    <Autorizacao perfisPermitidos={[getGestorEmpresa(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                        getFinanceiroCaixa(this.props.empresaSelecionada.id),
                        getAdminEmpresa(this.props.empresaSelecionada.id)]}>
                        <button type="button" className="vx-btn-danger"
                                onClick={() => this.devolverFechamentoCaixa()}>
                            <i className="material-icons">undo</i>Devolver
                        </button>
                        <button type="button" className="vx-btn-primary"
                                onClick={() => this.aprovarFechamentoCaixa()}>
                            <i className="material-icons">check_circle</i>Aprovar
                        </button>
                    </Autorizacao>
                </div>)
        }
        return ''
    }


    render() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;

        const exibirBotaoSalvar = this.validarValoresReaisInfomados() || this.validarCamposTextoInformados()

        const ehGestorOuOperador = validaPerfis([
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroCaixa(this.props.empresaSelecionada.id),
            getOperadorEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroAgencia(this.props.empresaSelecionada.id)]);

        const naoPodeAlterarValores = !validaPerfis([
                ...getPerfisVendedores(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getFinanceiroAgencia(this.props.empresaSelecionada.id)])
            || (this.props.fechamentoCaixa.id && (this.props.fechamentoCaixa.situacao === 'ENVIADO' || this.props.fechamentoCaixa.situacao === 'APROVADO'))
            || (this.props.fechamentoCaixa.idUsuario !== this.props.idUsuario && !ehGestorOuOperador);

        const exibirCampoComentario = (validaPerfis([
                ...getPerfisVendedores(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroAgencia(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id)]) && (this.props.fechamentoCaixa.situacao === 'ABERTO' || this.props.fechamentoCaixa.situacao === 'DEVOLVIDO')
            && (this.props.fechamentoCaixa.idUsuario === this.props.idUsuario || ehGestorOuOperador))
            || (validaPerfis([getAdminEmpresa(this.props.empresaSelecionada.id),
              getGestorEmpresa(this.props.empresaSelecionada.id)]) && (this.props.fechamentoCaixa.situacao === 'ENVIADO'));

        return (
            <div className="modal fade show" id="modalFechamentoCaixa" role="dialog"
                 aria-labelledby="modalFechamentoCaixa"
                 aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content vx-modal-content">
                        <div className="vx-modal-header">
                            <div className="vx-modal-header-left">
                                <i className="material-icons">account_balance_wallet</i>
                                <span className="vx-modal-title">
                                    {this.props.fechamentoCaixa.nomeUsuario} — {this.props.fechamentoCaixa.dataFechamento}
                                </span>
                            </div>
                            <button type="button" className="vx-modal-close" data-dismiss="modal"
                                    onClick={() => this.fecharModal()}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>
                        <form onSubmit={handleSubmit(this.submit)}>
                            <div className="vx-modal-body">

                                <div className="vx-modal-section">
                                    <div className="vx-modal-section-title">
                                        <i className="material-icons">receipt_long</i>
                                        Taxas e Serviços
                                    </div>
                                    <div className="vx-modal-fields-grid">
                                        <Field name='totalTaxaServico' validate={[required, maxValueMonetario]}
                                               component={renderFieldMonetario} className="form-control"
                                               label='(+) Total Tx de Serviço' readOnly/>
                                        <Field name='totalPedagio' validate={[required, maxValueMonetario]}
                                               component={renderFieldMonetario} className="form-control"
                                               label='(+) Total Tx de Pedágio' readOnly/>
                                        <Field name='totalExcessoBagagem' validate={[required]} component={renderFieldMonetario}
                                               className="form-control" label='(+) Total excesso bagagem' readOnly/>
                                        <Field name='totalTaxaEmbarqueCEA' validate={[required, maxValueMonetario]}
                                               component={renderFieldMonetario} className="form-control"
                                               label='(=) Total Tx de Embarque CEA'
                                               handleChange={this.alterarValorTotal} readOnly/>
                                    </div>
                                </div>

                                <div className="vx-modal-section">
                                    <div className="vx-modal-section-title">
                                        <i className="material-icons">swap_horiz</i>
                                        Adiantamentos e Despesas
                                    </div>
                                    <div className="vx-modal-fields-grid">
                                        <Field name='totalAdiantamentoBaixado' validate={[required, maxValueMonetario]}
                                               component={renderFieldMonetario} className="form-control"
                                               label="(+) Total adiantamento baixado" handleChange={this.alterarValorTotal}
                                               readOnly={naoPodeAlterarValores}/>
                                        <Field name='totalAdiantamentoLancado' validate={[required, maxValueMonetario]}
                                               component={renderFieldMonetario} className="form-control"
                                               label="(-) Total adiantamento lançado" handleChange={this.alterarValorTotal}
                                               readOnly={naoPodeAlterarValores}/>
                                        <Field name='totalDespesas' validate={[required, maxValueMonetario]}
                                               component={renderFieldMonetario} className="form-control"
                                               label="(-) Total despesas" handleChange={this.alterarValorDespesas}
                                               readOnly={naoPodeAlterarValores}/>
                                        <Field name='totalLancamentoAReceber' validate={[required, maxValueMonetario]}
                                               component={renderFieldMonetario} className="form-control"
                                               label="(-) Total Lançamentos a receber" handleChange={this.alterarValorTotal}
                                               readOnly={naoPodeAlterarValores}/>
                                    </div>
                                </div>

                                <div className="vx-modal-section">
                                    <div className="vx-modal-section-title">
                                        <i className="material-icons">security</i>
                                        Seguro e Impostos
                                    </div>
                                    <div className="vx-modal-fields-grid">
                                        <Field name='totalTarifaSeguro' validate={[required, maxValueMonetario]}
                                               component={renderFieldMonetario} className="form-control"
                                               label='(-) Total de seguro' readOnly/>
                                        <Field name='totalImpostoRetido' validate={[required, maxValueMonetario]}
                                               component={renderFieldMonetario} className="form-control"
                                               label="(-) Total imposto retido" readOnly/>
                                        <Field name='totalTarifaSeguroImpostoRetido' validate={[required, maxValueMonetario]}
                                               component={renderFieldMonetario} className="form-control"
                                               label="(-) Total tarifa seguro e imposto retido" readOnly/>
                                    </div>
                                </div>

                                <div className="vx-modal-section">
                                    <div className="vx-modal-section-title">
                                        <i className="material-icons">payments</i>
                                        Pagamentos e Cancelamentos
                                    </div>
                                    <div className="vx-modal-fields-grid">
                                        <Field name='totalVendas' validate={[required]} component={renderFieldMonetario}
                                               className="form-control" label='(+) Total de vendas' readOnly/>
                                        <Field name='totalRecebidoCartao' validate={[required]} component={renderFieldMonetario}
                                               className="form-control" label="(-) Total recebido cartão" readOnly/>
                                        <Field name='totalRecebidoCartaoSite' validate={[required]} component={renderFieldMonetario}
                                               className="form-control" label="(-) Total recebido cartão no site" readOnly/>
                                        <Field name='totalRecebidoPix' validate={[required]} component={renderFieldMonetario}
                                               className="form-control" label="(-) Total recebido PIX" readOnly/>
                                        <Field name='totalRecebidoLinkPagamento' validate={[required]} component={renderFieldMonetario}
                                               className="form-control" label="(-) Total recebido Link de Pagamento" readOnly/>
                                        <Field name='totalCancelamento' validate={[required]} component={renderFieldMonetario}
                                               className="form-control" label="(-) Total de cancelamentos" readOnly/>
                                        <Field name='totalCustoCancelamento' validate={[required]}
                                               component={renderFieldMonetario} className="form-control"
                                               label="(+) Total residual de cancelamentos" readOnly/>
                                    </div>
                                </div>

                                <div className="vx-modal-section">
                                    <div className="vx-modal-section-title">
                                        <i className="material-icons">calculate</i>
                                        Totais
                                    </div>
                                    <div className="vx-modal-fields-grid">
                                        <Field name='totalComissao' validate={[required]} component={renderFieldMonetario}
                                               className="form-control" label="(-) Total comissão" readOnly/>
                                        <Field name='totalReimpressaoRecibo' validate={[required]} component={renderFieldMonetario}
                                               className="form-control" label="(-) Total comissão Reimpressão" readOnly/>
                                        <Field name='totalComissaoSeguro' validate={[required]} component={renderFieldMonetario}
                                               className="form-control" label="(-) Total comissão Seguro" readOnly/>
                                        <Field name='totalDesconto' validate={[required]} component={renderFieldMonetario}
                                               className="form-control" label="(Informativo) Total desconto" readOnly/>
                                        <Field name='totalDeposito' validate={[required]} component={renderFieldMonetario}
                                               className="form-control" label="(=) Total do depósito" readOnly/>
                                    </div>
                                </div>

                                {(exibirCampoComentario || (this.props.fechamentoCaixa.situacao !== 'ABERTO' || this.props.fechamentoCaixa.ultimoHistorico)) &&
                                    <div className="vx-modal-section">
                                        <div className="vx-modal-section-title">
                                            <i className="material-icons">comment</i>
                                            Comentários
                                        </div>
                                        {exibirCampoComentario &&
                                            <Field name='observacao' css="form-control col-md-12" component={renderTextArea}
                                                   className="form-control" max={1500} label="Seu comentário:"/>}
                                        {!(this.props.fechamentoCaixa.situacao === 'ABERTO' && !this.props.fechamentoCaixa.ultimoHistorico) &&
                                            <Field name='ultimoComentario' css="form-control col-md-12"
                                                   component={renderTextArea} className="form-control"
                                                   label="Último comentário:" readOnly={true}/>}
                                    </div>
                                }

                                {this.exibirComprovantesPagamento()}

                                {this.props.empresaSelecionada.habilitadoCpfCnpjTitularComprovante &&
                                    <div className="vx-modal-section">
                                        <div className="vx-modal-section-title">
                                            <i className="material-icons">badge</i>
                                            Dados do Comprovante
                                        </div>
                                        <div className="vx-modal-fields-grid">
                                            <Field name='cpfCnpjTitularComprovante' type="text" component={renderFieldCpfCnpj}
                                                label="CPF/CNPJ - Titular do Comprovante"
                                                validate={[validarCpfCnpjInformado]} css="form-control" readOnly={false}/>
                                            <Field name='dataComprovanteDeposito' type="text" max={10} component={renderFieldDataNascimento}
                                                label='Data Comprovante Depósito' css="form-control"/>
                                        </div>
                                    </div>
                                }

                                {this.props.usuariosEmpresa && this.props.usuariosEmpresa.habilitadoCieloEcommerce &&
                                    <div className="vx-modal-section">
                                        <div className="vx-modal-section-title">
                                            <i className="material-icons">qr_code_2</i>
                                            Depósito via PIX (Cielo E-commerce)
                                        </div>
                                        {this.exibirPixDeposito()}
                                    </div>
                                }

                                {this.props.usuariosEmpresa && this.props.usuariosEmpresa.habilitadoSicoob &&
                                    <div className="vx-modal-section">
                                        <div className="vx-modal-section-title">
                                            <i className="material-icons">qr_code_2</i>
                                            Depósito via PIX (Sicoob)
                                        </div>
                                        {this.exibirPixDepositoSicoob()}
                                    </div>
                                }

                                <div className="vx-modal-section">
                                    <div className="vx-modal-section-title">
                                        <i className="material-icons">attach_file</i>
                                        Comprovante de Depósito
                                    </div>
                                    {this.exibirAnexar()}
                                </div>

                            </div>
                            {this.exibirBotoesVendedor(invalid, submitting, exibirBotaoSalvar)}
                        </form>
                        {this.exibirBotoesGestorOperador()}
                    </div>
                </div>
            </div>
        )
    }
}

const selector = formValueSelector('formularioFechamentoCaixa');

export function mapStateToProps(state) {    
    return {
        vendas: state.vendas,
        empresaSelecionada: state.empresaSelecionada,
        usuariosEmpresa: state.usuariosEmpresa,
        fechamentoCaixa: state.fechamentoCaixa,
        idUsuario: state.authentication.idUsuario,
        paginaAtual: state.paginaAtualFechamentoCaixa,
        filtrosAdicionados: state.filtrosAdicionadosFechamentoCaixa,
        registrosPorPagina: state.registrosPorPaginaFechamentoCaixa,
        initialValues: {
            totalTaxaEmbarqueCEA: state.fechamentoCaixa.totais.totalTaxaEmbarqueCEA,
            totalTaxaServico: state.fechamentoCaixa.totais.totalTaxaServico,
            totalPedagio: state.fechamentoCaixa.totais.totalPedagio,
            totalTarifaSeguro: state.fechamentoCaixa.totais.totalTarifaSeguro,
            totalAdiantamentoBaixado: state.fechamentoCaixa.totais.totalAdiantamentoBaixado,
            totalAdiantamentoLancado: state.fechamentoCaixa.totais.totalAdiantamentoLancado,
            totalDespesas: state.fechamentoCaixa.totais.totalDespesas,
            totalImpostoRetido: state.fechamentoCaixa.totais.totalImpostoRetido,
            totalTarifaSeguroImpostoRetido: state.fechamentoCaixa.totais.totalTarifaSeguroImpostoRetido,
            totalVendas: state.fechamentoCaixa.totais.totalVendas,
            totalRecebidoCartao: state.fechamentoCaixa.totais.totalRecebidoCartao,
            totalRecebidoCartaoSite: state.fechamentoCaixa.totais.totalRecebidoCartaoSite,
            totalCancelamento: state.fechamentoCaixa.totais.totalCancelamento,
            totalCustoCancelamento: state.fechamentoCaixa.totais.totalCustoCancelamento,
            totalExcessoBagagem: state.fechamentoCaixa.totais.totalExcessoBagagem,
            totalFreteRecebido: state.fechamentoCaixa.totais.totalFreteRecebido,
            totalComissao: state.fechamentoCaixa.totais.totalComissao,
            totalReimpressaoRecibo: state.fechamentoCaixa.totais.totalReimpressaoRecibo,
            totalComissaoSeguro: state.fechamentoCaixa.totais.totalComissaoSeguro,
            totalDesconto: state.fechamentoCaixa.totais.totalDesconto,
            totalDeposito: state.fechamentoCaixa.totais.totalDeposito,
            totalRecebidoPix: state.fechamentoCaixa.totais.totalRecebidoPix,
            totalRecebidoLinkPagamento: state.fechamentoCaixa.totais.totalRecebidoLinkPagamento,
            totalLancamentoAReceber: state.fechamentoCaixa.totais.totalLancamentoAReceber,
            ultimoComentario: state.fechamentoCaixa.ultimoHistorico ? state.fechamentoCaixa.ultimoHistorico.observacao : '',
            urlComprovanteTransferencia: state.fechamentoCaixa.urlComprovanteTransferencia ? state.fechamentoCaixa.urlComprovanteTransferencia : null,
            nomeComprovanteTransferencia: state.fechamentoCaixa.nomeComprovanteTransferencia ? state.fechamentoCaixa.nomeComprovanteTransferencia : null,
            comprovanteTransferencia: state.fechamentoCaixa.comprovanteTransferencia ? state.fechamentoCaixa.comprovanteTransferencia : null,
            cpfCnpjTitularComprovante: state.fechamentoCaixa.cpfCnpjTitularComprovante,
            dataComprovanteDeposito: state.fechamentoCaixa.dataComprovanteDeposito,
        },
        totalTaxaEmbarqueCEA: selector(state, 'totalTaxaEmbarqueCEA'),
        totalCancelamento: selector(state, 'totalCancelamento'),
        totalCustoCancelamento: selector(state, 'totalCustoCancelamento'),
        totalTaxaServico: selector(state, 'totalTaxaServico'),
        totalAdiantamentoBaixado: selector(state, 'totalAdiantamentoBaixado'),
        totalAdiantamentoLancado: selector(state, 'totalAdiantamentoLancado'),
        totalDespesas: selector(state, 'totalDespesas'),
        totalImpostoRetido: selector(state, 'totalImpostoRetido'),
        totalTarifaSeguroImpostoRetido: selector(state, 'totalTarifaSeguroImpostoRetido'),
        totalVendas: selector(state, 'totalVendas'),
        totalRecebidoCartao: selector(state, 'totalRecebidoCartao'),
        totalRecebidoCartaoSite: selector(state, 'totalRecebidoCartaoSite'),
        totalFrete: selector(state, 'totalFrete'),
        totalExcessoBagagem: selector(state, 'totalExcessoBagagem'),
        totalComissao: selector(state, 'totalComissao'),
        totalReimpressaoRecibo: selector(state, 'totalReimpressaoRecibo'),
        totalComissaoSeguro: selector(state, 'totalComissaoSeguro'),
        totalDesconto: selector(state, 'totalDesconto'),
        totalDeposito: selector(state, 'totalDeposito'),
        totalLancamentoAReceber: selector(state, 'totalLancamentoAReceber'),
        urlComprovanteTransferencia: selector(state, 'urlComprovanteTransferencia'),
        nomeComprovanteTransferencia: selector(state, 'nomeComprovanteTransferencia'),
        comprovanteTransferencia: selector(state, 'comprovanteTransferencia'),
        base64ComprovanteTransferencia: selector(state, 'base64ComprovanteTransferencia'),
        observacao: selector(state, 'observacao'),
        cpfCnpjTitularComprovante: selector(state, 'cpfCnpjTitularComprovante'),
        dataComprovanteDeposito:  selector(state, 'dataComprovanteDeposito'),
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        enviarFechamentoCaixa,
        aprovarFechamentoCaixa,
        devolverFechamentoCaixa,
        buscarFechamentoDia,
        buscarFechamentosCaixa,
        salvarFechamentoCaixa,
        gerarPixFechamentoCaixa,
        verificarPagamentoPixFechamentoCaixa,
        usuarioEmpresaHabilitadoCieloEcommerce,
        gerarPixFechamentoCaixaSicoob,
        verificarPagamentoPixFechamentoCaixaSicoob,
        usuarioEmpresaHabilitadoSicoob
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioFechamentoCaixa',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalFechamentoCaixa))
